import { differenceInMinutes, differenceInSeconds, differenceInHours } from "date-fns";
import { useCallback, useEffect, useState } from "react";

function switchTimerMode(mode, time) {
  const now = new Date().getTime();

  if (mode === "increase") {
    const diff = now - time;

    return [differenceInHours(diff, 0), differenceInMinutes(diff, 0), differenceInSeconds(diff, 0)];
  }

  return [differenceInHours(time, now), differenceInMinutes(time, now), differenceInSeconds(time, now) % 60];
}

export function useTimer({
  mode = "increase",
  defaultStartTime = new Date().getTime(),
  startRunning = false,
}) {
  const [startTime, setStartTime] = useState(defaultStartTime);
  const [timer, setTimer] = useState([0, 0, 0]);
  const [isRunning, setIsRunning] = useState(startRunning);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isRunning) return clearInterval(interval);
      setTimer(switchTimerMode(mode, startTime));
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime, isRunning]);

  const start = useCallback((time = defaultStartTime) => {
    setIsRunning(true);
    setStartTime(time);
  });

  const stop = useCallback(() => {
    setIsRunning(false);
  });

  return {
    timer,
    isRunning,
    start,
    stop,
  };
}
